import { render, staticRenderFns } from "./SinglePoi.tpl?vue&type=template&id=a18b32fe&"
import script from "./SinglePoi.vue?vue&type=script&lang=ts&"
export * from "./SinglePoi.vue?vue&type=script&lang=ts&"
import style0 from "./SinglePoi.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports